export default "__VITE_ASSET__6d698e61__"